import { useStore } from 'lib/store'
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon,
  TelegramShareButton,
  TelegramIcon
} from 'next-share'
import { useRouter } from 'next/router'

export const ShareVacancy = () => {
  const { asPath } = useRouter()
  const company = useStore(store => store.company)
  const url = `${company.slug}.vagas.solides.com.br${asPath}`

  return (
    <div className="flex items-center justify-end gap-1">
      <FacebookShareButton url={url}>
        <FacebookIcon size={18} borderRadius={10} />
      </FacebookShareButton>
      <WhatsappShareButton url={url}>
        <WhatsappIcon size={18} borderRadius={10} />
      </WhatsappShareButton>
      <TelegramShareButton url={url}>
        <TelegramIcon size={18} borderRadius={10} />
      </TelegramShareButton>
      <TwitterShareButton url={url}>
        <TwitterIcon size={18} borderRadius={10} />
      </TwitterShareButton>
      <EmailShareButton url={url}>
        <EmailIcon size={18} borderRadius={10} />
      </EmailShareButton>
      <LinkedinShareButton url={url}>
        <LinkedinIcon size={18} borderRadius={10} />
      </LinkedinShareButton>
    </div>
  )
}
